import React from 'react';

// Ordered row for a zone: R A R A R ... (aisles sit between racks).
export const buildZoneItems = (zone) => {
  const items = [];
  for (let r = 1; r <= zone.racks; r++) {
    items.push({ type: 'rack', index: r });
    if (r <= zone.aisles) items.push({ type: 'aisle', index: r });
  }
  // any extra configured aisles go at the end
  for (let a = zone.racks + 1; a <= zone.aisles; a++) items.push({ type: 'aisle', index: a });
  return items;
};

// Selection #1: pick a rack or an aisle.
const LayoutSelector = ({ warehouse, selection, onSelect }) => (
  <div className="layout-selector">
    {warehouse.zones.map((zone) => (
      <div key={zone.key} className={`zone zone-${zone.key}`}>
        <div className="zone-title">
          {zone.label}
          <span className="zone-meta">
            {zone.racks} racks · {zone.aisles} aisles
          </span>
        </div>
        <div className="zone-floor">
          {buildZoneItems(zone).map((item) => {
            const selected =
              selection &&
              selection.zoneKey === zone.key &&
              selection.type === item.type &&
              selection.index === item.index;
            return (
              <button
                key={`${item.type}-${item.index}`}
                type="button"
                className={`cell ${item.type}${selected ? ' selected' : ''}`}
                onClick={() => onSelect({ zoneKey: zone.key, type: item.type, index: item.index })}
              >
                {item.type === 'rack' ? 'Rack' : 'Aisle'} {item.index}
              </button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);

export default LayoutSelector;
